import React from 'react';
import { cn } from '@rocco/utils/cn';

interface CollapsiblePageLayoutProps {
    children: React.ReactNode;
    sidePanel?: React.ReactNode;
    hideSidePanel?: boolean;
}

/**
 * A layout with a main content and a side panel that can be collapsed. The
 * side panel is always hidden on mobile.
 */
export const CollapsiblePageLayout = ({
    children,
    sidePanel,
    hideSidePanel = false,
}: CollapsiblePageLayoutProps) => {
    return (
        <div className="flex min-h-screen w-full px-2.5 md:overflow-visible md:px-12.5">
            <aside
                className={cn(
                    'hidden transition-all will-change-[transform,width,opacity,margin-right] md:block',
                    hideSidePanel
                        ? 'opacity-0 md:w-0 md:min-w-0 md:-translate-x-115'
                        : 'md:-mr-115 md:w-115 md:min-w-115'
                )}
                style={{
                    transitionDuration: LAYOUT_TRANSITION_DURATION,
                    transitionTimingFunction: LAYOUT_TIMING_FUNCTION,
                }}
                data-testid={'side-panel'}
            >
                {sidePanel}
            </aside>
            <div
                className={cn(
                    'max-w-full grow transition-[margin-left] will-change-[margin-left]',
                    !hideSidePanel && 'md:ml-[28.75rem]'
                )}
                style={{
                    transitionDuration: LAYOUT_TRANSITION_DURATION,
                    transitionTimingFunction: LAYOUT_TIMING_FUNCTION,
                }}
            >
                {children}
            </div>
        </div>
    );
};

export const LAYOUT_TRANSITION_DURATION = `0.3s`;
export const LAYOUT_TIMING_FUNCTION = 'cubic-bezier(0.215,0.61,0.355,1)';
